export const API_URL = process.env.REACT_APP_SERVER;
export default API_URL;
